export const settings = {
  // Language & Region Section
  'settings.preferredLanguage': 'Langue préférée',
  'settings.languageRegion.title': 'Langue et Région',
  'settings.languageRegion.description': 'Définir votre langue préférée et les paramètres régionaux',
  'settings.languageRegion.livePreview': 'Aperçu en Direct',
  'settings.languageRegion.interfaceLanguage': 'Langue de l\'interface pour les menus, boutons et messages système',
  'settings.languageRegion.autoDetectionNote': '💡 La langue est automatiquement définie en fonction de votre sélection de pays, mais vous pouvez la modifier ici.',
  'settings.languageRegion.currencyDisplay': 'Affichage de la Devise',
  'settings.languageRegion.currencyDescription': 'Devise utilisée pour afficher les montants de financement',
  'settings.languageRegion.dateFormat': 'Format de Date',
  'settings.languageRegion.dateDescription': 'Format d\'affichage des dates utilisé dans l\'interface',
  'settings.languageRegion.regionalInfo': 'Informations Régionales',
  'settings.languageRegion.languageAffects': '• La langue affecte tous les textes de l\'interface utilisateur',
  'settings.languageRegion.currencyAffects': '• Les paramètres de devise modifient l\'affichage des montants',
  'settings.languageRegion.dateAffects': '• Les formats de date sont utilisés dans les calendriers et listes',
  'settings.languageRegion.changesImmediate': '• Les modifications prennent effet immédiatement',

  // Profile Information Section
  'settings.profile.title': 'Informations du Profil',
  'settings.profile.description': 'Gérer les informations de votre compte et votre photo de profil',
  'settings.profile.photo': 'Photo de Profil',
  'settings.profile.uploadPhoto': 'Télécharger une photo pour personnaliser votre compte (max 5MB, JPG/PNG/WebP)',
  'settings.profile.firstName': 'Prénom',
  'settings.profile.lastName': 'Nom de famille',
  'settings.profile.jobTitle': 'Titre du poste',
  'settings.profile.jobTitlePlaceholder': 'ex. Responsable du Développement Commercial',
  'settings.profile.email': 'Adresse Email',
  'settings.profile.emailNote': '',
  'settings.profile.phoneNumber': 'Numéro de téléphone',
  'settings.profile.phoneNumberPlaceholder': '',
  'settings.profile.phoneNumberNote': 'Optionnel - pour vous contacter en cas de besoin',
  'settings.profile.editProfile': 'Modifier le Profil',
  'settings.profile.changePassword': 'Changer le Mot de Passe',
  'settings.profile.changeEmail': 'Modifier l\'Email',
  'settings.profile.connectedAccounts': 'Comptes Connectés',
  'settings.profile.connected': 'Connecté',
  'settings.profile.notConnected': 'Non connecté',
  'settings.profile.disconnect': 'Déconnecter',
  'settings.profile.connect': 'Connecter',
  'settings.profile.accountsNote': 'Connecter des comptes supplémentaires permet la connexion unique et aide à synchroniser vos informations de profil professionnel.',

  // Notifications Section
  'settings.notifications.title': 'Notifications',
  'settings.notifications.description': 'Contrôler comment et quand vous recevez des notifications de subvention360',
  'settings.notifications.fundingMatches': 'Résultats de Financement',
  'settings.notifications.fundingMatchesDesc': 'Nouvelles subventions qui correspondent à votre profil et intérêts',
  'settings.notifications.platformUpdates': 'Mises à Jour de la Plateforme',
  'settings.notifications.platformUpdatesDesc': 'Nouvelles fonctionnalités, améliorations et annonces système',
  'settings.notifications.tipsAndPractices': 'Conseils et Bonnes Pratiques',
  'settings.notifications.tipsAndPracticesDesc': 'Guides utiles et conseils d\'experts pour des candidatures réussies',
  'settings.notifications.highPriority': 'priorité élevée',
  'settings.notifications.mediumPriority': 'priorité moyenne',
  'settings.notifications.lowPriority': 'priorité faible',
  'settings.notifications.email': 'Email',
  'settings.notifications.enableEmail': 'Activer les notifications par email',
  'settings.notifications.inApp': 'Dans le Navigateur',
  'settings.notifications.enableInApp': 'Activer les notifications dans le navigateur',
  'settings.notifications.frequency': 'Fréquence',
  'settings.notifications.immediate': 'Immédiat',
  'settings.notifications.dailyDigest': 'Résumé Quotidien',
  'settings.notifications.weeklyDigest': 'Résumé Hebdomadaire',
  'settings.notifications.disabled': 'Désactivé',
  'settings.notifications.timing': 'Timing des Notifications',
  'settings.notifications.timingImmediate': '• Immédiat: Envoyé dès que l\'événement se produit',
  'settings.notifications.timingDaily': '• Résumé Quotidien: Résumé groupé envoyé une fois par jour (9h00)',
  'settings.notifications.timingWeekly': '• Résumé Hebdomadaire: Résumé hebdomadaire envoyé le lundi (9h00)',
  'settings.notifications.timingDisabled': '• Désactivé: Aucune notification pour ce type',
  'settings.notifications.recommended': '💡 Paramètres Recommandés',
  'settings.notifications.recommendedFunding': '• Résultats de Financement: Email et notifications navigateur immédiates (ne ratez pas les opportunités!)',
  'settings.notifications.recommendedPlatform': '• Mises à Jour de la Plateforme: Résumé hebdomadaire pour rester informé sans surcharge',
  'settings.notifications.recommendedTips': '• Conseils et Bonnes Pratiques: Résumé hebdomadaire pour apprendre à votre rythme',

  // Theme & UI Section
  'settings.theme.title': 'Thème et Interface',
  'settings.theme.description': 'Personnaliser l\'apparence et la mise en page de votre interface',
  'settings.theme.livePreview': 'Mode Aperçu en Direct',
  'settings.theme.enablePreview': 'Activer l\'Aperçu',
  'settings.theme.theme': 'Thème',
  'settings.theme.light': 'Clair',
  'settings.theme.lightDesc': 'Interface propre et lumineuse',
  'settings.theme.dark': 'Sombre',
  'settings.theme.darkDesc': 'Reposant pour les yeux en faible luminosité',
  'settings.theme.system': 'Système',
  'settings.theme.systemDesc': 'Suit le paramètre de votre appareil',
  'settings.theme.fontSize': 'Taille de Police',
  'settings.theme.fontSizeStandard': 'Taille lisible standard',
  'settings.theme.dashboardDensity': 'Densité du Tableau de Bord',
  'settings.theme.spacious': 'Spacieux',
  'settings.theme.spaciousDesc': 'Plus d\'espace de respiration et de rembourrage',
  'settings.theme.previewSample': 'Échantillon d\'Aperçu',
  'settings.theme.sampleCard': 'Exemple de Carte de Tableau de Bord',
  'settings.theme.sampleDesc': 'Voici comment votre interface apparaîtra avec les paramètres sélectionnés.',
  'settings.theme.customizationTips': 'Conseils de Personnalisation',
  'settings.theme.tip1': '• Utilisez le Mode Aperçu pour tester les modifications avant de les appliquer',
  'settings.theme.tip2': '• Le thème système bascule automatiquement en fonction de votre appareil',
  'settings.theme.tip3': '• La densité compacte est idéale pour les grands écrans et les utilisateurs avancés',
  'settings.theme.tip4': '• Tous les changements sont sauvegardés automatiquement et synchronisés sur vos appareils',

  // Privacy & Security Section
  'settings.privacy.title': 'Confidentialité et Sécurité',
  'settings.privacy.description': 'Gérer vos paramètres de sécurité, sessions actives et confidentialité des données',
  'settings.privacy.twoFactor': 'Authentification à Deux Facteurs',
  'settings.privacy.authenticatorApp': 'Application d\'Authentification',
  'settings.privacy.twoFactorDesc': 'Ajouter une couche de sécurité supplémentaire avec l\'authentification TOTP',
  'settings.privacy.setUp2FA': 'Configurer 2FA',
  'settings.privacy.activeSessions': 'Sessions Actives',
  'settings.privacy.currentSession': 'Actuelle',
  'settings.privacy.revoke': 'Révoquer',
  'settings.privacy.inactive': 'Inactive',
  'settings.privacy.exportData': 'Exporter Vos Données',
  'settings.privacy.exportDesc': 'Télécharger une copie complète de vos données personnelles stockées dans subvention360. Cela inclut votre profil, préférences et historique d\'activité.',
  'settings.privacy.completeData': 'Données Complètes (JSON)',
  'settings.privacy.completeDataDesc': 'Export structuré complet avec toutes les métadonnées - idéal pour la sauvegarde',
  'settings.privacy.downloadJSON': 'Télécharger JSON',
  'settings.privacy.spreadsheetFormat': 'Format Tableur (CSV)',
  'settings.privacy.spreadsheetDesc': 'Format tabulaire pour analyse dans Excel ou Google Sheets',
  'settings.privacy.downloadCSV': 'Télécharger CSV',
  'settings.privacy.deleteAccount': 'Supprimer le Compte',
  'settings.privacy.deleteWarning': 'La suppression du compte est permanente et ne peut pas être annulée. Toutes vos données seront définitivement supprimées.',
  'settings.privacy.deleteMyAccount': 'Supprimer Mon Compte',
  'settings.privacy.changeEmail': 'Modifier l\'adresse email',
  'settings.privacy.emailConfirmation': 'Un email de confirmation sera envoyé à votre nouvelle adresse',
  'settings.privacy.currentEmail': 'Email actuel',
  'settings.privacy.newEmail': 'Nouvelle adresse email',
  'settings.privacy.changeEmailButton': 'Modifier l\'email',

  // Personal Settings Main
  'settings.personal.title': 'Paramètres Personnels',
  'settings.personal.description': 'Gérer les informations de votre compte, préférences et paramètres de confidentialité',

  // Settings Page Main
  'settings.title': 'Paramètres',
  'settings.description': 'Gérer les informations de votre compte, préférences et paramètres de confidentialité',
  'settings.tabs.personal': 'Paramètres Personnels',
  'settings.tabs.organization': 'Organisation',
  'settings.tabs.team': 'Équipe',
  'settings.tabs.suspended': 'Vos profils suspendu',
  'settings.tabs.dashboards': 'Tableaux de Bord Avancés',
  'settings.tabs.admin': 'Fonctionnalités Admin',
  'settings.dashboards.title': 'Tableaux de Bord Avancés',
  'settings.dashboards.description': 'Accéder aux tableaux de bord spécialisés basés sur votre rôle et permissions',
  'settings.admin.title': 'Fonctionnalités Admin',
  'settings.admin.description': 'Outils administratifs pour la gestion et le monitoring du système',
  'settings.admin.roleRequired': 'Rôle Admin Requis',
  'settings.admin.switchRole': 'Passer au rôle Admin en utilisant le sélecteur de rôle pour accéder à ces fonctionnalités.',

  // Suspended Accounts
  'settings.suspended.title': 'Vos profils suspendu',
  'settings.suspended.description': 'Gérez vos profils suspendus. Les profils suspendus sont masqués de votre tableau de bord et exclus de la facturation.',
  'settings.suspended.noSuspended': 'Aucun compte suspendu',
  'settings.suspended.noSuspendedDesc': 'Vous n\'avez aucun profil suspendu. Les profils suspendus peuvent être restaurés à tout moment.',
  'settings.suspended.suspendedOn': 'Suspendu le',
  'settings.suspended.restoreProfile': 'Restaurer le Profil',
  'settings.suspended.deletePermanently': 'Supprimer Définitivement',
  'settings.suspended.confirmRestore': 'Êtes-vous sûr de vouloir restaurer ce profil ?',
  'settings.suspended.confirmDelete': 'Êtes-vous sûr de vouloir supprimer définitivement ce profil ? Cette action est irréversible.',
  'settings.suspended.restoring': 'Restauration...',
  'settings.suspended.deleting': 'Suppression...',

  // Language Feature Info Section
  'settings.languageFeature.title': 'Détection Automatique de Langue',
  'settings.languageFeature.description': 'subvention360 définit automatiquement la langue de votre interface en fonction du pays sélectionné',
  'settings.languageFeature.howItWorks': 'Comment Fonctionne la Détection Automatique de Langue',
  'settings.languageFeature.step1': 'Lorsque vous sélectionnez un pays lors de la configuration du profil, nous définissons automatiquement la langue de l\'interface',
  'settings.languageFeature.step2': 'Vous pouvez modifier manuellement la langue à tout moment dans les Paramètres',
  'settings.languageFeature.step3': 'Votre choix de langue manuel est toujours préservé',
  'settings.languageFeature.supportedCountries': 'Pays avec Détection Automatique de Langue',
  'settings.languageFeature.englishCountries': 'Pays Utilisant l\'Anglais par Défaut',
  'settings.languageFeature.coverageTitle': 'Couverture de Traduction Complète',
  'settings.languageFeature.coverageDescription': 'Tous les éléments d\'interface, navigation, formulaires et contenu utilisateur ont été entièrement traduits dans les langues prises en charge (à l\'exception du contenu des subventions qui varie selon la source).',

  // Role Settings Section (Type de profil)
  'settings.role.title': 'Type de Profil',
  'settings.role.description': 'Sélectionnez comment vous utilisez subvention360',
  'settings.role.help.consultant': 'Gérez plusieurs profils clients et offrez des services de conseil en subventions',
  'settings.role.help.business_owner': 'Recherchez des financements pour votre propre entreprise',
  'settings.role.help.team_member': 'Accédez aux profils partagés par votre organisation',
  'settings.role.current': 'actuel',
  'settings.role.save': 'Enregistrer les modifications',
  'settings.role.confirm_message': 'Êtes-vous sûr de vouloir changer votre rôle ? Cela modifiera votre interface et vos permissions. La page sera rechargée.',
  'settings.role.alert_title': 'Changement de rôle :',
  'settings.role.alert_message': 'Votre interface et vos permissions seront modifiées. La page sera rechargée automatiquement.',
  'settings.role.toast.success_title': 'Rôle mis à jour',
  'settings.role.toast.success_description': 'Votre rôle a été changé à {role}. Redirection...',
  'settings.role.toast.error_title': 'Échec de la mise à jour',
  'settings.role.toast.error_description': 'Impossible de mettre à jour votre rôle. Veuillez réessayer.',

  // Organization Settings Section
  'settings.organization.details.title': 'Détails de l\'Organisation',
  'settings.organization.details.description': 'Gérer le nom et les informations de base de votre organisation',
  'settings.organization.name.label': 'Nom de l\'Organisation',
  'settings.organization.name.placeholder': 'Mon Entreprise',
  'settings.organization.name.help': 'Ce nom est affiché à tous les membres de l\'équipe',
  'settings.organization.logo.title': 'Logo de l\'Organisation',
  'settings.organization.logo.description': 'Téléchargez le logo de votre organisation pour personnaliser votre tableau de bord',
  'settings.organization.logo.upload': 'Télécharger le Logo',
  'settings.organization.logo.change': 'Changer le Logo',
  'settings.organization.logo.uploading': 'Téléchargement...',
  'settings.organization.logo.formats': '• Formats : JPG, PNG, SVG ou WebP',
  'settings.organization.logo.size': '• Taille maximale : 2MB',
  'settings.organization.logo.recommended': '• Recommandé : Image carrée (512x512px ou plus)',
  'settings.organization.visibility.title': 'Visibilité de l\'Équipe',
  'settings.organization.visibility.description': 'Contrôler qui peut voir la liste des membres de l\'équipe',
  'settings.organization.visibility.label': 'Qui peut voir les membres de l\'équipe ?',
  'settings.organization.visibility.all': 'Tous les membres de l\'équipe',
  'settings.organization.visibility.admins': 'Administrateurs uniquement',
  'settings.organization.visibility.help.all': 'Tous les membres de l\'équipe peuvent voir les noms et emails de chacun',
  'settings.organization.visibility.help.admins': 'Seuls les administrateurs peuvent voir la liste complète des membres',
  'settings.organization.email.title': 'Restrictions Email',
  'settings.organization.email.description': 'Contrôler quels domaines email peuvent être invités à votre organisation',
  'settings.organization.email.domain.label': 'Restreindre les invitations au domaine email',
  'settings.organization.email.domain.placeholder': '@votreentreprise.com',
  'settings.organization.email.domain.help': 'Laisser vide pour autoriser n\'importe quel domaine email. Exemple : @ecoemit.com',
  'settings.organization.email.external.label': 'Autoriser les invitations externes',
  'settings.organization.email.external.description': 'Permettre d\'inviter des utilisateurs en dehors de la restriction de domaine',
  'settings.organization.save': 'Enregistrer les modifications',
  'settings.organization.saving': 'Enregistrement...',
  'settings.organization.unsaved': 'Vous avez des modifications non enregistrées',
  'settings.organization.notMember': 'Vous n\'êtes membre d\'aucune organisation.',

  // Team Settings Section
  'settings.team.title': 'Membres de l\'Équipe',
  'settings.team.description': 'Gérer qui a accès à votre organisation',
  'settings.team.invite': 'Inviter un Membre',
  'settings.team.members.title': 'Membres Actifs',
  'settings.team.members.count': '{count} membre(s)',
  'settings.team.members.you': 'Vous',
  'settings.team.members.admin': 'Administrateur',
  'settings.team.members.member': 'Membre',
  'settings.team.members.viewer': 'Observateur',
  'settings.team.members.customRole': 'Rôle Personnalisé',
  'settings.team.members.edit': 'Modifier',
  'settings.team.members.remove': 'Retirer',
  'settings.team.members.viewPermissions': 'Voir les Permissions',
  'settings.team.members.editPermissions': 'Modifier les Permissions',
  'settings.team.members.joined': 'Rejoint {date}',
  'settings.team.invitations.title': 'Invitations en Attente',
  'settings.team.invitations.count': '{count} invitation(s)',
  'settings.team.invitations.sent': 'Envoyée {date}',
  'settings.team.invitations.expires': 'Expire {date}',
  'settings.team.invitations.resend': 'Renvoyer',
  'settings.team.invitations.revoke': 'Révoquer',
  'settings.team.invitations.none': 'Aucune invitation en attente',
  'settings.team.delete.title': 'Retirer le membre',
  'settings.team.delete.description': 'Êtes-vous sûr de vouloir retirer {name} de votre organisation ? Cette action ne peut pas être annulée.',
  'settings.team.delete.confirm': 'Retirer le membre',
  'settings.team.delete.cancel': 'Annuler',
  'settings.team.delete.removing': 'Retrait...',
  'settings.team.toast.removed': 'Membre de l\'équipe retiré avec succès',
  'settings.team.toast.removeFailed': 'Échec du retrait du membre',
  'settings.team.toast.cannotRemoveSelf': 'Impossible de vous retirer vous-même',
  'settings.team.toast.cannotRemoveSelfDesc': 'Vous êtes le seul administrateur. Promouvez d\'abord un autre membre comme administrateur.',
  'settings.team.toast.inviteRevoked': 'Invitation révoquée',
  'settings.team.toast.inviteResent': 'Invitation renvoyée',
  'settings.team.toast.inviteRevokeFailed': 'Échec de la révocation de l\'invitation',
  'settings.team.toast.inviteResendFailed': 'Échec du renvoi de l\'invitation',
  'settings.team.toast.loadFailed': 'Échec du chargement des membres de l\'équipe',
  'settings.team.notMember': 'Vous n\'êtes membre d\'aucune organisation.',

  // Subscription Management - Pause Feature
  'settings.subscription.pauseMembership.title': 'Mettre en pause l\'abonnement',
  'settings.subscription.pauseMembership.description': 'Suspendre temporairement votre abonnement',
  'settings.subscription.pauseMembership.info': 'Vous pouvez mettre en pause votre abonnement à tout moment. Vous conserverez l\'accès jusqu\'à la fin de votre période de facturation actuelle.',
  'settings.subscription.pauseMembership.button': 'Mettre en pause l\'abonnement',
  'settings.subscription.pauseMembership.currentlyPaused': 'Abonnement actuellement en pause',
  'settings.subscription.pauseMembership.pausedUntil': 'Accès jusqu\'au {date}',
  'settings.subscription.pauseMembership.resumeButton': 'Reprendre l\'abonnement',

  // Pause Dialog
  'settings.subscription.pauseDialog.title': 'Mettre en pause votre abonnement ?',
  'settings.subscription.pauseDialog.description': 'Votre abonnement sera suspendu après la fin de votre période de facturation actuelle. Aucun paiement ne sera prélevé pendant la pause.',
  'settings.subscription.pauseDialog.accessUntil': 'Accès jusqu\'au :',
  'settings.subscription.pauseDialog.whatHappens': 'Ce qui va se passer :',
  'settings.subscription.pauseDialog.point1': 'Vous conservez l\'accès complet jusqu\'à la fin de votre période de facturation',
  'settings.subscription.pauseDialog.point2': 'Aucun paiement ne sera prélevé après cette date',
  'settings.subscription.pauseDialog.point3': 'Vous pourrez reprendre votre abonnement à tout moment',
  'settings.subscription.pauseDialog.resumeAnytime': 'Vous pourrez reprendre votre abonnement à tout moment via le portail de facturation.',
  'settings.subscription.pauseDialog.confirm': 'Confirmer la pause',
  'settings.subscription.pauseDialog.pausing': 'Mise en pause...',
  'settings.subscription.pauseDialog.successTitle': 'Abonnement mis en pause',
  'settings.subscription.pauseDialog.successDescription': 'Votre abonnement est maintenant en pause. Accès jusqu\'au {date}',
  'settings.subscription.pauseDialog.errorTitle': 'Erreur lors de la pause',
  'settings.subscription.pauseDialog.errorDescription': 'Impossible de mettre en pause l\'abonnement. Veuillez réessayer.',

  // Paused State Blocker
  'subscription.paused.title': 'Abonnement en pause',
  'subscription.paused.description': 'Votre abonnement est actuellement en pause. Pour continuer à utiliser la plateforme, veuillez reprendre votre abonnement.',
  'subscription.paused.accessEnded': 'Accès terminé le :',
  'subscription.paused.pausedSince': 'En pause depuis le {date}',
  'subscription.paused.resumeInstructions': 'Pour reprendre votre abonnement et retrouver l\'accès à la plateforme, cliquez sur le bouton ci-dessous.',
  'subscription.paused.resumeButton': 'Reprendre l\'abonnement',
  'subscription.paused.redirecting': 'Redirection en cours...',
  'subscription.paused.helpText': 'Vous serez redirigé vers le portail de facturation Stripe pour gérer votre abonnement.',
  'subscription.paused.needHelp': 'Besoin d\'aide ?',
  'subscription.paused.redirectError': 'Erreur de redirection',
  'subscription.paused.redirectErrorDescription': 'Impossible d\'ouvrir le portail de facturation. Veuillez réessayer.',

  // Payment Failed Blocker
  'subscription.paymentFailed.title': 'Échec du paiement',
  'subscription.paymentFailed.accessExpired': 'Votre période de grâce est expirée. Veuillez mettre à jour votre moyen de paiement pour continuer à utiliser la plateforme.',
  'subscription.paymentFailed.gracePeriodActive': 'Le paiement de votre abonnement a échoué. Vous conservez l\'accès pendant la période de grâce.',
  'subscription.paymentFailed.failedOn': 'Paiement échoué le :',
  'subscription.paymentFailed.gracePeriodRemaining': 'Il vous reste {days} jour(s) pour mettre à jour votre moyen de paiement avant la perte d\'accès.',
  'subscription.paymentFailed.gracePeriodExpiredMessage': 'Votre période de grâce de 10 jours est expirée. L\'accès à la plateforme est suspendu.',
  'subscription.paymentFailed.whatToDo': 'Que faire maintenant :',
  'subscription.paymentFailed.step1': 'Cliquez sur "Mettre à jour le paiement" ci-dessous',
  'subscription.paymentFailed.step2': 'Ajoutez ou modifiez votre moyen de paiement dans le portail Stripe',
  'subscription.paymentFailed.step3': 'L\'accès sera rétabli immédiatement après la mise à jour',
  'subscription.paymentFailed.updatePaymentButton': 'Mettre à jour le paiement',
  'subscription.paymentFailed.redirecting': 'Redirection en cours...',
  'subscription.paymentFailed.redirectError': 'Erreur de redirection',
  'subscription.paymentFailed.billingPortalNote': 'Vous serez redirigé vers le portail de facturation Stripe sécurisé.',

  // Settings Placeholders
  'settings.placeholders.enterNewPassword': 'Entrez le nouveau mot de passe',
  'settings.placeholders.confirmNewPassword': 'Confirmez le nouveau mot de passe',
  'settings.placeholders.newEmailAddress': 'nouveau@email.com',
  'settings.placeholders.deleteAccountConfirmation': 'SUPPRIMER MON COMPTE',
  'settings.placeholders.expertDisplayName': 'Ex: Cabinet Conseil Expertise',
  'settings.placeholders.expertBio': 'Décrivez votre expertise et vos services...',
  'settings.placeholders.billingEmail': 'comptabilite@entreprise.fr',

  // Additional translations for UI elements
  'settings.preview.today': 'Aujourd\'hui',
  'settings.preview.sampleFunding': 'Financement exemple',
  'settings.theme.light.description': 'Interface propre et lumineuse',
  'settings.theme.dark.description': 'Reposant pour les yeux en faible luminosité',
  'settings.theme.system.description': 'Suit le paramètre de votre appareil',
  'settings.fontSize.small': 'Petit',
  'settings.fontSize.small.description': 'Texte compact pour plus de contenu',
  'settings.fontSize.medium': 'Moyen',
  'settings.fontSize.medium.description': 'Taille lisible standard',
  'settings.fontSize.large': 'Grand',
  'settings.fontSize.large.description': 'Texte plus grand pour une meilleure lisibilité',
  'settings.density.compact': 'Compact',
  'settings.density.compact.description': 'Plus d\'informations dans moins d\'espace',
  'settings.density.spacious.description': 'Plus d\'espace de respiration et de rembourrage',
  'settings.privacy.unknownIP': 'IP inconnue',
  'settings.privacy.justNow': 'À l\'instant',
  'settings.privacy.hoursAgo': '{hours} heures',
  'settings.team.activeMembers.title': 'Membres Actifs',
  'settings.team.activeMembers.description': 'Membres de l\'équipe ayant accepté leur invitation',
  'settings.team.invitations.description': 'Invitations envoyées mais pas encore acceptées',
  'settings.team.members.youBadge': 'Vous',

  // Invite Member Dialog
  'settings.team.invite.title': 'Inviter un membre',
  'settings.team.invite.description': 'Envoyer une invitation pour ajouter un nouveau membre à votre organisation',
  'settings.team.invite.email.label': 'Adresse email',
  'settings.team.invite.email.placeholder': 'collegue@entreprise.com',
  'settings.team.invite.email.invalid': 'Adresse email invalide',
  'settings.team.invite.email.domainOnly': 'Seuls les emails {domain} sont autorisés',
  'settings.team.invite.role.label': 'Rôle',
  'settings.team.invite.role.admin': 'Administrateur',
  'settings.team.invite.role.admin.description': 'Gérer les membres de l\'équipe et accéder à toutes les données',
  'settings.team.invite.role.member': 'Membre',
  'settings.team.invite.role.member.description': 'Créer et modifier les profils clients et les candidatures',
  'settings.team.invite.role.viewer': 'Observateur',
  'settings.team.invite.role.viewer.description': 'Accès en lecture seule pour consulter les clients',
  'settings.team.invite.permissions.title': 'Permissions',
  'settings.team.invite.permissions.custom': '(Permissions personnalisées)',
  'settings.team.invite.permissions.view_clients': 'Voir les clients',
  'settings.team.invite.permissions.view_clients.description': 'Peut voir les profils clients et leurs détails',
  'settings.team.invite.permissions.create_clients': 'Créer des clients',
  'settings.team.invite.permissions.create_clients.description': 'Peut créer de nouveaux profils clients',
  'settings.team.invite.permissions.edit_clients': 'Modifier les clients',
  'settings.team.invite.permissions.edit_clients.description': 'Peut modifier les profils clients existants',
  'settings.team.invite.permissions.delete_clients': 'Supprimer les clients',
  'settings.team.invite.permissions.delete_clients.description': 'Peut supprimer des profils clients',
  'settings.team.invite.permissions.manage_team': 'Gérer l\'équipe',
  'settings.team.invite.permissions.manage_team.description': 'Peut inviter, retirer et gérer les membres de l\'équipe',
  'settings.team.invite.permissions.manage_settings': 'Gérer les paramètres',
  'settings.team.invite.permissions.manage_settings.description': 'Peut modifier les paramètres de l\'organisation',
  'settings.team.invite.clientAccess.title': 'Accès aux clients',
  'settings.team.invite.clientAccess.all': 'Tous les clients',
  'settings.team.invite.clientAccess.all.description': 'Ce membre aura accès à tous les clients actuels et futurs',
  'settings.team.invite.clientAccess.specific': 'Clients spécifiques ({count} sélectionnés)',
  'settings.team.invite.clientAccess.specific.description': 'Ce membre ne verra que les clients sélectionnés',
  'settings.team.invite.clientAccess.configure': 'Configurer',
  'settings.team.invite.domainWarning': 'Seuls les emails se terminant par {domain} peuvent être invités',
  'settings.team.invite.cancel': 'Annuler',
  'settings.team.invite.send': 'Envoyer l\'invitation',
  'settings.team.invite.sending': 'Envoi...',
  'settings.team.invite.success': 'Invitation envoyée avec succès',
  'settings.team.invite.success.description': '{email} recevra un email d\'invitation',
  'settings.team.invite.error': 'Échec de l\'envoi de l\'invitation',
  'settings.team.invite.error.invalidEmail': 'Veuillez entrer une adresse email valide',
} as const;